!(function(e) {
	var t,
		n,
		o,
		i,
		c,
		l,
		a,
		d =
			'<svg><symbol id="icon-vote" viewBox="0 0 1024 1024"><path d="M478.982332 121.215548c25.328622 104.932862 85.936396 175.491166 133.879859 236.09894l6.332155 6.332155 73.272085 89.55477 38.897527-104.932862c6.332155-22.614841 15.378092-45.229682 21.710247-70.558304 99.5053 102.219081 169.159011 252.381625 122.120141 434.204947-16.282686 60.607774-51.561837 117.597173-95.886926 149.257951-47.943463 41.611307-131.166078 89.55477-262.332155 89.55477-169.159011 0-257.809187-79.60424-299.420495-127.547703-12.664311-12.664311-22.614841-25.328622-28.946996-37.992933-63.321555-108.551237-73.272085-220.720848-25.328622-315.70318 15.378092 15.378092 31.660777 31.660777 47.943463 44.325088 9.045936 9.95053 18.996466 16.282686 25.328622 22.614841l137.498233 140.212014-26.233216-194.487632c-31.660777-160.113074 47.943463-281.328622 131.166078-360.932862zM530.54417 0C374.04947 104.932862 246.501767 277.710247 274.54417 491.194346c-34.374558-35.279152-98.600707-75.985866-117.597174-140.212014C51.109541 472.19788 23.067138 647.689046 128 820.466431c9.95053 15.378092 22.614841 34.374558 37.992933 50.657244 45.229682 54.275618 153.780919 152.876325 350.982332 152.876325 150.162544 0 246.04947-56.989399 306.657244-104.932862 60.607774-44.325088 102.219081-121.215548 121.215548-185.441696 64.226148-242.431095-60.607774-453.201413-229.766785-568.084806 0 57.893993-25.328622 128.452297-37.992933 166.44523-73.272085-85.936396-146.54417-172.777385-146.544169-331.985866z"  ></path></symbol><symbol id="icon-selected" viewBox="0 0 1024 1024"><path d="M256 51.2a51.2 51.2 0 0 0-51.2 51.2v868.1984L452.5056 793.6a102.4 102.4 0 0 1 118.9888 0L819.2 970.5984V102.4a51.2 51.2 0 0 0-51.2-51.2H256z m0-51.2h512a102.4 102.4 0 0 1 102.4 102.4v868.1984a51.2 51.2 0 0 1-80.9472 41.6768l-247.7056-176.9472a51.2 51.2 0 0 0-59.4944 0L234.496 1012.2752A51.2 51.2 0 0 1 153.6 970.5984V102.4a102.4 102.4 0 0 1 102.4-102.4z"  ></path></symbol><symbol id="icon-views" viewBox="0 0 1024 1024"><path d="M512 402.77333333a109.22666667 109.22666667 0 1 1-109.22666667 109.22666667 109.22666667 109.22666667 0 0 1 109.22666667-109.22666667m0-72.81777778a182.04444445 182.04444445 0 1 0 182.04444445 182.04444445 182.04444445 182.04444445 0 0 0-182.04444445-182.04444445z"  ></path><path d="M512 269.5168c214.6304 0 327.68 129.61564445 417.24586667 242.4832C839.68 625.0496 726.6304 754.4832 512 754.4832S184.32 625.0496 94.75413333 512C184.32 398.9504 297.3696 269.5168 512 269.5168m0-72.81777778C230.55928889 196.69902222 97.30275555 392.03271111 2.27555555 512c95.0272 119.96728889 228.28373333 315.30097778 509.72444445 315.30097778S926.69724445 631.96728889 1021.72444445 512c-95.0272-119.96728889-228.28373333-315.30097778-509.72444445-315.30097778z" fill="#333333" ></path></symbol></svg>',
		s = (t = document.getElementsByTagName('script'))[t.length - 1].getAttribute('data-injectcss');
	if (s && !e.__iconfont__svg__cssinject__) {
		e.__iconfont__svg__cssinject__ = !0;
		try {
			document.write(
				'<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>'
			);
		} catch (e) {
			console && console.log(e);
		}
	}
	function m() {
		l || ((l = !0), i());
	}
	(n = function() {
		var e,
			t,
			n,
			o,
			i,
			c = document.createElement('div');
		(c.innerHTML = d),
			(d = null),
			(e = c.getElementsByTagName('svg')[0]) &&
				(e.setAttribute('aria-hidden', 'true'),
				(e.style.position = 'absolute'),
				(e.style.width = 0),
				(e.style.height = 0),
				(e.style.overflow = 'hidden'),
				(t = e),
				(n = document.body).firstChild
					? ((o = t), (i = n.firstChild).parentNode.insertBefore(o, i))
					: n.appendChild(t));
	}),
		document.addEventListener
			? ~[ 'complete', 'loaded', 'interactive' ].indexOf(document.readyState)
				? setTimeout(n, 0)
				: ((o = function() {
						document.removeEventListener('DOMContentLoaded', o, !1), n();
					}),
					document.addEventListener('DOMContentLoaded', o, !1))
			: document.attachEvent &&
				((i = n),
				(c = e.document),
				(l = !1),
				(a = function() {
					try {
						c.documentElement.doScroll('left');
					} catch (e) {
						return void setTimeout(a, 50);
					}
					m();
				})(),
				(c.onreadystatechange = function() {
					'complete' == c.readyState && ((c.onreadystatechange = null), m());
				}));
})(window);
